export default __webpack_public_path__ + "static/media/slide6.fb01e3e8.jpg";